<!-- eslint-disable import/no-cycle -->
<!-- eslint-disable max-len -->
<!-- eslint-disable quote-props -->
<!-- eslint-disable camelcase -->
<!-- eslint-disable no-new -->
<script lang="ts">
  import { ref, reactive, onMounted, watch, onBeforeMount } from 'vue'

  import Breadcrumb from '@/components/Molecules/Breadcrumbs.vue'
  import Contact from '@/components/Molecules/Contact.vue'
  import Input from '@/components/Atoms/Input.vue'
  import Icon from '@/components/Atoms/Icon.vue'
  import CardContainer from './A1/components/Atoms/CardContainer.vue'
  import { onBeforeRouteLeave, useRoute } from 'vue-router'
  import {
    checkIfPluginIsInstalled,
    createPluginConnection,
    makeRequestToPlugin,
  } from './A1/services/pluginHttps'
  import {
    ValidateCertificateRequest,
    EmissionApiAbstractHandler,
  } from './A1/services/sisAr/ValidateCertificateRequest'
  import { getOs, UserOperateSystem } from '../utils/getOs'
  import { useModalControl } from './A1/store/pinia/useModalControl.store'
  import useSawNewsStore from './A1/store/pinia/useSawNews.store'
  import { ValidateReturnPlugin } from './A1/services/ValidateReturnPlugin'
  import { useDebounceFn } from '@vueuse/core'

  import ModalMobileWarning from './A1/modals/ModalMobileWarning.vue'
  import ModalRequestInProgress from './A1/modals/ModalRequestInProgress.vue'
  import ModalEmissionSteps from './A1/modals/ModalEmissionSteps.vue'
  import ModalDownloadCertificate from './A1/modals/ModalDownloadCertificate.vue'
  import ModalPluginDownload from './A1/modals/ModalPluginDownload.vue'
  import ModalPluginCertificatePassword from './A1/modals/ModalPluginCertificatePassword.vue'
  import ModalDifferentComputerError from './A1/modals/ModalDifferentComputerError.vue'
  import ModalPluginConfirmation from './A1/modals/ModalPluginConfirmation.vue'
  import ModalWrongCredentialsSisAr from './A1/modals/ModalWrongCredentialsSisAr.vue'
  import ModalTryAgain from './A1/modals/ModalTryAgain.vue'
  import ModalJava from './A1/modals/ModalJava.vue'
  import ModalPluginDownloadConfirmation from './A1/modals/ModalPluginDownloadConfirmation.vue'
  import ModalPluginExecutionConfirmation from './A1/modals/ModalPluginExecutionConfirmation.vue'
  import ModalPluginNotExecuting from './A1/modals/ModalPluginNotExecuting.vue'
  import ModalSetNewPassword from './A1/modals/ModalSetNewPassword.vue'
  import ModaolOnboardingVideo from './A1/modals/ModalOnboardingVideo.vue'

  import useEmissionStepsModal from './A1/composables/useEmissionStepsModal'
  import usePluginDownloadModal from './A1/composables/usePluginDownloadModal'
  import usePluginCertificatePasswordModal from './A1/composables/usePluginCertificatePasswordModal'
  import useDownloadCertificateModal from './A1/composables/useDownloadCertificateModal'
  import useDifferentComputerErrorModal from './A1/composables/useDifferentComputerErrorModal'
  import useModalWrongCredentials from './A1/composables/useModalWrongCredentials'
  import useRequestInProgressModal from './A1/composables/useRequestInProgressModal'
  import useTryAgainModal from './A1/composables/useTryAgainModal'
  import usePluginConfirmationModal from './A1/composables/usePluginConfirmationModal'
  import usePlguinDownloadConfirmationModal from './A1/composables/usePluginDownloadConfirmationModal'
  import usePluginExecutionConfirmation from './A1/composables/usePluginExecutionConfirmationModal'
  import usePluginNotExecutingModal from './A1/composables/usePluginNotExecutingModal'
  import useSetNewPasswordModal from './A1/composables/useSetNewPassword'
  import useOnboardingVideoModal from './A1/composables/useOnboardingVideoModal'
  import { usePlugin } from '@/store/Pinia/usePlugin.store'
  import { useOeRecaptcha } from '@/utils/useOeRecaptcha'

  export default {
    components: {
      Breadcrumb,
      Contact,
      CardContainer,
      'input-component': Input,
      'icon-component': Icon,
      ModalMobileWarning,
      ModalEmissionSteps,
      ModalPluginDownload,
      ModalPluginCertificatePassword,
      ModalDownloadCertificate,
      ModalWrongCredentialsSisAr,
      ModalDifferentComputerError,
      ModalTryAgain,
      ModalRequestInProgress,
      ModalPluginConfirmation,
      ModalJava,
      ModalPluginDownloadConfirmation,
      ModalPluginExecutionConfirmation,
      ModalPluginNotExecuting,
      ModalSetNewPassword,
      ModaolOnboardingVideo,
    },
    setup() {
      const pathList = {
        'Instalação em computador': 'issue/plugin',
      }

      const isAbleToContinue = ref(false)
      const token = ref('')
      const userData = reactive({
        username: '',
        baseUrl: '',
        password: '',
      })
      const userNameIsBeingEdited = ref(false)
      const passwordIsBeingEdited = ref(false)
      const passwordCrt = ref('')

      const validateCertificateRequest = ref<ValidateCertificateRequest>()
      const userError = ref('')
      const passError = ref('')
      const oeRecaptcha = useOeRecaptcha()

      watch(
        () => {
          if (userData.username.trim().length === 0) {
            return false
          }

          if (userData.password.trim().length === 0) {
            return false
          }

          if (userError.value.trim().length > 0) {
            return false
          }

          if (passError.value.trim().length > 0) {
            return false
          }

          return true
        },
        (isValid) => {
          isAbleToContinue.value = isValid
        },
        {
          immediate: true,
          deep: true,
        },
      )

      watch(
        userData,
        async (newUserData, oldUserData) => {
          const newDataUsernameLeft =
            (newUserData.username as string)?.replaceAll('"', '')?.trim() || ''
          const oldDataUsernameLeft =
            (oldUserData?.username as string)?.replaceAll('"', '')?.trim() || ''

          if (newDataUsernameLeft !== oldDataUsernameLeft) {
            const arLink = await EmissionApiAbstractHandler.getArLink(
              userData.username.split(' ').shift() || '',
            )
            userData.baseUrl = !arLink.length ? userData.baseUrl : arLink
          }
        },
        { immediate: true, deep: true },
      )

      function validatePassword(newPassword: string) {
        passError.value = ''

        if (newPassword.trim().length === 0) {
          return
        }

        if (passwordIsBeingEdited.value) {
          return
        }

        if (newPassword.trim().length < 8 || newPassword.trim().length > 20) {
          passError.value = 'Senha inválida'
        }
      }

      watch(
        () => userData.password,
        (newPassword) => {
          validatePassword(newPassword)
        },
        { immediate: true },
      )

      watch(
        () => passwordIsBeingEdited.value,
        (passwordInputState) => {
          if (!passwordInputState) {
            validatePassword(userData.password)
          }
        },
        { immediate: true },
      )

      function validateUserName(newUserName: string) {
        userError.value = ''

        if (newUserName.trim().length === 0) {
          return
        }

        const splited = newUserName.trim().split(' ')

        if (userNameIsBeingEdited.value) {
          return
        }

        if (splited.length !== 2) {
          userError.value = 'Usuário inválido'
          return
        }

        const usernameLeftPart = splited[0]
        const usernameRightPart = splited[1]

        if (
          usernameLeftPart.length < 16 ||
          usernameLeftPart.length > 20 ||
          usernameRightPart.length !== 14
        ) {
          userError.value = 'Usuário inválido'
        }
      }

      watch(
        () => userData.username,
        (newUserName) => {
          validateUserName(newUserName)
        },
        { immediate: true },
      )

      watch(
        () => userNameIsBeingEdited.value,
        (userNameInputState) => {
          if (!userNameInputState) {
            validateUserName(userData.username)
          }
        },
        { immediate: true },
      )

      const route = useRoute()
      const { solicitation, ar_url } = route.query

      if (solicitation) {
        userData.username =
          (solicitation as string)?.replaceAll('"', '')?.trim() || ''
      }

      if (ar_url) {
        userData.baseUrl = (ar_url as string)?.replaceAll('"', '')?.trim() || ''
      }

      const { emissionStepsModal } = useEmissionStepsModal()
      const { downloadCertificateModal } = useDownloadCertificateModal()
      const { pluginDownloadModal } = usePluginDownloadModal()
      const { pluginCertificatePasswordModal } =
        usePluginCertificatePasswordModal()
      const { differentComputerErrorModal } = useDifferentComputerErrorModal()
      const { requestInProgressModal } = useRequestInProgressModal()
      const { wrongCredentialsModal } = useModalWrongCredentials()
      const { tryAgainModal } = useTryAgainModal()
      const { pluginConfimartionModal } = usePluginConfirmationModal()
      const { pluginDownloadConfirmationModal } =
        usePlguinDownloadConfirmationModal()
      const { pluginExecutionConfirmation } = usePluginExecutionConfirmation()
      const { pluginNotExecutingModal } = usePluginNotExecutingModal()
      const { setNewPasswordModal } = useSetNewPasswordModal()
      const { onboardingVideoModal, showOnboardingVideoModal } =
        useOnboardingVideoModal()

      const modalMobileWarning = ref<InstanceType<
        typeof ModalMobileWarning
      > | null>(null)
      const modalJava = ref<InstanceType<typeof ModalJava> | null>(null)

      async function navigateToChosePasswordModal() {
        const modalControlStore = useModalControl()
        const {
          showPluginCertificatePasswordModal,
          hidePluginCertificatePasswordModal,
        } = usePluginCertificatePasswordModal()

        await modalControlStore.show({
          modalId: 'pluginCertificatePasswordModal',
          show: showPluginCertificatePasswordModal,
          hide: hidePluginCertificatePasswordModal,
        })
      }

      async function issueCertificate() {
        const modalControlStore = useModalControl()

        const {
          setEmissionStep,
          showEmissionStepsModal,
          hideEmissionStepsModal,
        } = useEmissionStepsModal()

        setEmissionStep(1)

        await modalControlStore.show({
          modalId: 'emissionStepsModal',
          show: showEmissionStepsModal,
          hide: hideEmissionStepsModal,
        })

        if (userData.username.length !== 0) {
          const arLink = await EmissionApiAbstractHandler.getArLink(
            userData.username.split(' ').shift() || '',
          )
          userData.baseUrl = !arLink.length ? userData.baseUrl : arLink
        }

        await createPluginConnection().then(() => {
          makeRequestToPlugin('/emission/', 'HEAD', {}, {}).then((response) => {
            token.value = (response?.headers?.get('x-csrf-token') ||
              '') as string
          })
        })

        if (passwordCrt.value.length === 0 && checkIfPluginIsInstalled()) {
          await navigateToChosePasswordModal()
          return
        }

        const makeRequest = async () =>
          makeRequestToPlugin(
            '/emission/',
            'POST',
            {
              username: userData.username,
              password: userData.password,
              baseUrl: userData.baseUrl,
              passwordCrt: passwordCrt.value,
            },
            {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token.value}`,
            },
          )

        const validateReturnPlugin = new ValidateReturnPlugin({
          makeRequest,
          clearUserData: () => {
            userData.username = ''
            userData.password = ''
            userData.baseUrl = ''
          },
        })

        await EmissionApiAbstractHandler.getArLink(
          userData.username.split(' ').shift() || '',
        ).then((link) => {
          userData.baseUrl = !link.length ? userData.baseUrl : link
        })

        let recaptchaToken = await oeRecaptcha.getToken('solcheckstatus')

        validateCertificateRequest.value = new ValidateCertificateRequest({
          payload: {
            raUrl: userData.baseUrl,
            code: userData.username.split(' ').shift() || '',
            password: userData.password,
            recaptchaToken,
          },
          callback: validateReturnPlugin.dispatch,
        })

        await validateCertificateRequest.value.dispatch()
      }

      const debouncedIssueCertificate = useDebounceFn(issueCertificate, 300)

      onBeforeMount(() => {
        const pluginStore = usePlugin()
        pluginStore.clear()
        passError.value = ''
        userError.value = ''
      })

      onMounted(async () => {
        passError.value = ''
        userError.value = ''
        isAbleToContinue.value = false
        passwordCrt.value = ''

        oeRecaptcha.showBadge()

        const osInfo = getOs()
        const sawNewsStore = useSawNewsStore()

        if (
          osInfo.os === UserOperateSystem.IOS ||
          osInfo.os === UserOperateSystem.ANDROID ||
          osInfo.os === UserOperateSystem.UNKNOWN
        ) {
          modalMobileWarning.value?.show()
          return
        }

        setTimeout(() => {
          if (!sawNewsStore.sawNews) {
            showOnboardingVideoModal()
          }
        }, 2000)
      })

      onBeforeRouteLeave(() => {
        oeRecaptcha.hideBadge()
      })

      async function proceed(password: string) {
        if (password.length === 0) {
          passwordCrt.value = userData.password
          return debouncedIssueCertificate()
        }

        passwordCrt.value = password
        return debouncedIssueCertificate()
      }

      return {
        pathList,
        modalMobileWarning,
        modalJava,
        tryAgainModal,
        downloadCertificateModal,
        pluginDownloadModal,
        pluginCertificatePasswordModal,
        differentComputerErrorModal,
        emissionStepsModal,
        pluginConfimartionModal,
        pluginDownloadConfirmationModal,
        pluginExecutionConfirmation,
        userData,
        userNameIsBeingEdited,
        passwordIsBeingEdited,
        userError,
        passError,
        isAbleToContinue,
        issueCertificate,
        navigateToChosePasswordModal,
        debouncedIssueCertificate,
        requestInProgressModal,
        wrongCredentialsModal,
        pluginNotExecutingModal,
        setNewPasswordModal,
        onboardingVideoModal,
        proceed,
        showOnboardingVideoModal,
      }
    },
  }
</script>

<template>
  <div class="container">
    <section class="breadcrumb-wrapper pt-3">
      <breadcrumb :path-list="pathList" />
    </section>

    <section class="page-title-wrapper text-start pt-4">
      <h2 class="fw-600">Instalação em computador</h2>
    </section>

    <section class="row pt-5 px-3">
      <div class="col-md-6 d-none d-lg-block">
        <img
          alt="emitir-certificado"
          src="@/assets/images/instalar-certificado-ssl.svg"
        />
      </div>

      <div class="col-12 col-lg-6">
        <div class="w-100 d-flex justify-content-start mb-3">
          <button id="news-button" @click="showOnboardingVideoModal">
            <span class="me-2">Veja a novidade</span>
            <font-awesome-icon :icon="['fab', 'youtube']" />
          </button>
        </div>

        <p class="fs-6 text-start">
          Para prosseguir com a instalação do seu Certificado Digital, insira
          seu usuário e senha de emissão.
        </p>

        <div class="pb-3">
          <div class="d-flex justify-content-start align-items-center pb-2">
            <span class="fs-6 pe-2">Usuário *</span>
          </div>

          <input-component
            v-model="userData.username"
            icon="user"
            type="text"
            placeholder="Exemplo: 00ED000000 000000000"
            :error-log="userError"
            @focused="userNameIsBeingEdited = true"
            @blured="userNameIsBeingEdited = false"
          />
        </div>

        <div>
          <div class="d-flex justify-content-start align-items-center pb-2">
            <span class="fs-6 pe-2">Senha de emissão *</span>
          </div>

          <input-component
            v-model="userData.password"
            icon="lock"
            type="password"
            placeholder="Digite sua senha aqui"
            :error-log="passError"
            @focused="passwordIsBeingEdited = true"
            @blured="passwordIsBeingEdited = false"
          />
        </div>

        <div id="faqAccordionUserName" class="accordion mt-4">
          <div class="accordion-item">
            <div
              id="faqAccordionQuestionWhereIsUserName"
              class="accordion-header"
            >
              <button
                class="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#faqAccordionAnswerWhereUsUserName"
                aria-expanded="false"
                aria-controls="faqAccordionAnswerWhereUsUserName"
              >
                Onde encontro meu usuário?
              </button>
            </div>
            <div
              id="faqAccordionAnswerWhereUsUserName"
              class="accordion-collapse collapse"
              aria-labelledby="faqAccordionQuestionWhereIsUserName"
              data-bs-parent="#faqAccordionUserName"
            >
              <div class="accordion-body">
                <p class="text-start fs-6 m-0">
                  Você pode encontrar seu usuário no seu
                  <strong>e-mail</strong> com o assunto
                  <strong>“Emissão de Certificado Digital APROVADA”</strong> ou
                  no <strong>Documento Reservado</strong>.
                  <br />
                  <br />
                  A sequência é
                  <strong>composta por letras, números e espaço</strong>.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div id="faqAccordionPassword" class="accordion mt-4">
          <div class="accordion-item">
            <div
              id="faqAccordionQuestionWhatIsThePassword"
              class="accordion-header"
            >
              <button
                class="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#faqAccordionAnswerWhatIsThePassword"
                aria-expanded="false"
                aria-controls="faqAccordionAnswerWhatIsThePassword"
              >
                O que é a senha de emissão?
              </button>
            </div>
            <div
              id="faqAccordionAnswerWhatIsThePassword"
              class="accordion-collapse collapse"
              aria-labelledby="faqAccordionQuestionWhatIsThePassword"
              data-bs-parent="#faqAccordionPassword"
            >
              <div class="accordion-body">
                <p class="text-start fs-6 m-0">
                  <strong>É a senha criada por você</strong> no momento do
                  <strong>preenchimento dos dados</strong> do seu Certificado
                  Digital.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-end pt-4">
          <button
            id="next-step-button"
            :disabled="!isAbleToContinue"
            class="btn btn-primary"
            :class="[isAbleToContinue ? 'btn-primary' : 'btn-secondary']"
            @click="() => debouncedIssueCertificate()"
          >
            Avançar
            <icon-component name="arrow-right" />
          </button>
        </div>
      </div>
    </section>

    <section class="pt-4">
      <card-container>
        <span>Não conseguiu instalar o Certificado Digital?</span>
        <span
          class="link"
          @click="modalJava?.show()"
          @keydown="modalJava?.show()"
          >Clique aqui</span
        >
      </card-container>
    </section>

    <section class="pt-1">
      <contact />
    </section>

    <modal-mobile-warning ref="modalMobileWarning" />
    <modal-emission-steps ref="emissionStepsModal" />
    <modal-download-certificate ref="downloadCertificateModal" />
    <modal-plugin-download ref="pluginDownloadModal" />
    <modal-different-computer-error ref="differentComputerErrorModal" />
    <modal-request-in-progress ref="requestInProgressModal" />
    <modal-wrong-credentials-sis-ar ref="wrongCredentialsModal" />
    <modal-try-again ref="tryAgainModal" />
    <modal-plugin-confirmation
      ref="pluginConfimartionModal"
      @retry="issueCertificate"
    />
    <modal-java ref="modalJava" />
    <modal-plugin-download-confirmation ref="pluginDownloadConfirmationModal" />
    <modal-plugin-execution-confirmation
      ref="pluginExecutionConfirmation"
      @retryCertificateIssuing="issueCertificate"
    />
    <modal-plugin-not-executing ref="pluginNotExecutingModal" />
    <modal-plugin-certificate-password
      ref="pluginCertificatePasswordModal"
      @chosePasswordConfirm="() => proceed('')"
    />
    <modal-set-new-password ref="setNewPasswordModal" @proceed="proceed" />
    <modaol-onboarding-video ref="onboardingVideoModal" />
  </div>
</template>

<style>
  .link {
    font-size: 1rem;
    font-weight: 400;
    color: #0080a3;
    cursor: pointer;
  }

  @media screen and (max-width: 992px) {
    #next-step-button {
      width: 100%;
    }
  }

  #news-button {
    background-color: var(--color-success);
    color: var(--color-grayscale-dark-500);
    font-weight: 600;
    padding: 6px 12px;
    border-radius: 900px;
    border: none;
  }

  .accordion-button {
    background: var(--color-grayscale-light) !important;
  }
</style>
